export default __webpack_public_path__ + "static/media/clairefontaine5.482a2454.jpg";